import {useState, useEffect, Fragment} from 'react';
import * as S from './LocationDataAccordion.styles';
import {
  PrimaryLink,
  FlexCentered,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {defaultTheme} from '@stencil/build-theme';
import {isValidArray} from '@stencil/hotels-utils/src/common-utils';
import useIsClient from '@stencil/hotels-hooks/src/useIsClient';
import HappyLocationLandmarkDwebIcon from '@stencil/icons/src/HappyLocationLandmarkDwebIcon/HappyLocationLandmarkDwebIcon';
import HappyTransitDwebIcon from '@stencil/icons/src/HappyTransitDwebIcon/HappyTransitDwebIcon';
import HappyHotelLocationDwebIcon from '@stencil/icons/src/HappyHotelLocationDwebIcon/HappyHotelLocationDwebIcon';

const LocationDataAccordion = props => {
  const {
    active,
    getPlaceEventPropsForMapInteraction,
    state,
    poiDataSelectorData,
    activeAccordionTab,
    toggleAccordion,
    selectedPlaces,
  } = props;

  const isClient = useIsClient();

  const getIcon = activeItem => {
    const iconsMapper = {
      Transit: HappyTransitDwebIcon,
      Landmarks: HappyLocationLandmarkDwebIcon,
    };
    if (iconsMapper[activeItem]) {
      return iconsMapper[activeItem];
    }
    return HappyHotelLocationDwebIcon;
  };

  if (!isClient) {
    return null;
  }

  return (
    <>
      {isValidArray(poiDataSelectorData) &&
        poiDataSelectorData.map(({category_type, category_data, googleMapLocationType}, index) => {
          const IconComponent = getIcon(category_type);
          return category_data?.length > 0 ? (
            <Fragment key={`${category_type}_${index}`}>
              <S.HeaderLocationDiv onClick={() => toggleAccordion(category_type)}>
                <FlexCentered>
                  {IconComponent && (
                    <IconComponent
                      height="2rem"
                      width="2rem"
                      margin="0 0.5rem 0 0"
                      fill={defaultTheme.colors.ash.base}
                    />
                  )}
                  <S.MapPOITextWrap>{category_type}</S.MapPOITextWrap>
                </FlexCentered>
                <S.ArrowDownNewWrap
                  supressHydrationWarning
                  transformStyle={
                    activeAccordionTab === category_type ? 'rotate(180deg)' : 'rotate(0deg)'
                  }
                />
              </S.HeaderLocationDiv>
              <S.LocationDetailOuter
                display={!(activeAccordionTab === category_type) ? 'none' : undefined}
                data-testid="d-landmark-list"
              >
                {category_data.map((item, index) => (
                  <li
                    key={`${item?.place_name}_${index}`}
                    className={`${
                      active.type === googleMapLocationType && active.index === index
                        ? 'active'
                        : ''
                    }`}
                    {...getPlaceEventPropsForMapInteraction({
                      place: {
                        crd: [Number(item?.location?.lat), Number(item?.location?.lon)],
                        dis: Number(item?.distance),
                        n: item?.place_name,
                        unit_display: item?.distanceUnit || 'km',
                        dist_display: Number(item?.distance),
                      },
                      typeOfPlace: category_type,
                      error: state.error,
                      index,
                    })}
                  >
                    <S.LocationDetailOuterWrapper>
                      <FlexCentered>
                        <S.DottedListSpan />
                        <S.LocationNameTextSpan>{item?.place_name}</S.LocationNameTextSpan>
                      </FlexCentered>
                      <PrimaryLink>{`${item?.distance}${item?.distanceUnit || 'Km'}`}</PrimaryLink>
                    </S.LocationDetailOuterWrapper>
                    {item?.category && <S.PropertyTypePara>{item?.category}</S.PropertyTypePara>}
                  </li>
                ))}
              </S.LocationDetailOuter>
            </Fragment>
          ) : null;
        })}
    </>
  );
};

export default LocationDataAccordion;
